import { trackClick } from '@marketplace/helpers/segment/index.js'
import { toggleBodyScroll } from '@marketplace/mixins/body.js'

export default {
    computed: {
        __currentOpenDrawer() {
            return this.$store?.state?.global?.drawer?.currentlyOpen || false
        },
        __deviceHeight() {
            return this.$store?.state?.global?.drawer?.deviceHeight || 100
        },
    },

    methods: {
        toggleDrawer(status) {
            this.$store.commit('global/updateDrawerStatus', status)
        },
        trackDrawerToggle(toggledDrawer, currentOpenDrawer) {
            const closeDrawer = toggledDrawer === false
            trackClick(
                `${closeDrawer ? 'Closed' : 'Opened'} a Drawer`,
                {
                    category: 'General',
                    drawerName: toggledDrawer || currentOpenDrawer,
                },
                ''
            )
        },
        __openDrawer(name, toggleBodyStatus = false) {
            this.trackDrawerToggle(name, this.__currentOpenDrawer)
            this.toggleDrawer(name)
            toggleBodyScroll(Boolean(name), toggleBodyStatus)
        },
    },
}
